import React, { Component } from 'react';
import { func, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { ensureListing, ensureUser } from '../../../util/data';

import css from './SearchMapPriceLabel.module.css';

class SearchMapPriceLabel extends Component {
  shouldComponentUpdate(nextProps) {
    const currentListing = ensureListing(this.props.listing);
    const nextListing = ensureListing(nextProps.listing);
    const currentAuthor = ensureUser(currentListing.author);
    const nextAuthor = ensureUser(nextListing.author);
    const isSameListing = currentListing.id.uuid === nextListing.id.uuid;
    const hasSamePrice = currentListing.attributes.price === nextListing.attributes.price;
    const hasSameAuthorName =
      currentAuthor.attributes.profile.displayName === nextAuthor.attributes.profile.displayName;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

    return !(
      isSameListing &&
      hasSamePrice &&
      hasSameAuthorName &&
      hasSameActiveStatus &&
      hasSameRefreshToken
    );
  }

  render() {
    const { className, rootClassName, listing, onListingClicked, isActive } = this.props;
    const currentListing = ensureListing(listing);
    const author = ensureUser(currentListing.author);
    const authorName = author.attributes.profile.displayName.trim().split(/\s+/)[0] || '';

    const classes = classNames(rootClassName || css.root, className);
    const priceLabelClasses = classNames(css.priceLabel, {
      [css.mapLabelActive]: isActive,
      [css.noPriceSetLabel]: !authorName,
    });
    const caretClasses = classNames(css.caret, { [css.caretActive]: isActive });

    return (
      <button className={classes} onClick={() => onListingClicked(currentListing)}>
        <div className={css.caretShadow} />
        <div className={priceLabelClasses}>{authorName}</div>
        <div className={caretClasses} />
      </button>
    );
  }
}

SearchMapPriceLabel.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchMapPriceLabel.propTypes = {
  className: string,
  rootClassName: string,
  listing: propTypes.listing.isRequired,
  onListingClicked: func.isRequired,
};

export default SearchMapPriceLabel;
